var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"dynamic-data-field-text"},[(_vm.icon)?_c('Icon',{staticClass:"mr-1",attrs:{"size":"12","icon":"DatabaseIcon"}}):_vm._e(),(_vm.field)?[_vm._v(_vm._s(_vm.field.label))]:[_vm._v(_vm._s(_vm.shortcode))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }